import z from 'zod'

export const sendCodeFormSchema = z.object({
  email: z.string().min(1, { message: 'Электронная почта не может быть ​​пустой' }),
})
